import {httpBulkTransmission, HttpBulkTransmissionOptions} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'

export const useBulkTransmission = (options?: UseMutationOptions<unknown, unknown, HttpBulkTransmissionOptions>) => {
    const queryClient = useQueryClient()

    return useMutation({
        ...options,
        mutationFn: httpBulkTransmission,
        onSuccess: async (data, variables, context) => {
            await queryClient.cancelQueries({
                queryKey: [QUERY_KEYS.PROJECTS]
            })
            await queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.PROJECTS]
            })
            variables.payload.projectIds.forEach(projectId => {
                queryClient.cancelQueries({
                    queryKey: [QUERY_KEYS.PROJECT, projectId]
                })
                queryClient.invalidateQueries({
                    queryKey: [QUERY_KEYS.PROJECT, projectId]
                })
            })
            options?.onSuccess?.(data, variables, context)
        }
    })
}
